var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var MediaQuery_1;
import React, { Component } from 'react';
import { MediaQueries } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { arrayOf, element, oneOf, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues, getLostProps, propagateProps } from '@philips-internal/oswald-ui-utils';
import MediaQueryAPI from './media-query-api.js';
const MediaQueryContainer = {
    name: '',
};
let MediaQuery = MediaQuery_1 = class MediaQuery extends Component {
    constructor() {
        super(...arguments);
        this.media = undefined;
        this.state = {
            render: true,
        };
        this.bindedScreenTest = this.screenTest.bind(this);
    }
    screenTest(event) {
        this.setState({
            render: event.matches,
        });
    }
    removeMatchMedia() {
        if (this.media) {
            this.media.removeListener(this.bindedScreenTest);
            this.media = undefined;
        }
    }
    createMatchMedia() {
        const { query = MediaQuery_1.defaultProps.query } = this.props;
        if (this.media) {
            this.removeMatchMedia();
        }
        this.media = window.matchMedia(query);
        this.media.addListener(this.bindedScreenTest);
        this.setState({
            render: this.media.matches,
        });
    }
    componentDidMount() {
        this.createMatchMedia();
    }
    componentDidUpdate(prevProps) {
        const { query = MediaQuery_1.defaultProps.query } = this.props;
        if (query === prevProps.query) {
            return;
        }
        this.createMatchMedia();
    }
    componentWillUnmount() {
        this.removeMatchMedia();
    }
    render() {
        const { render } = this.state;
        const { children, uuid } = this.props;
        const lostProps = getLostProps(MediaQuery_1.propTypes, this.props);
        if (!render) {
            return null;
        }
        return (React.createElement(Container, { className: "c-media-query", uuid: uuid }, propagateProps(children, lostProps)));
    }
};
MediaQuery.propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    query: oneOf(enumValues(MediaQueries)),
    uuid: string,
};
MediaQuery.defaultProps = {
    query: MediaQueries.NONE,
};
MediaQuery = MediaQuery_1 = __decorate([
    AwesomeComponent({ api: MediaQueryAPI, containers: [MediaQueryContainer], type: ComponentType.BEHAVIOR })
], MediaQuery);
export default MediaQuery;
//# sourceMappingURL=media-query.js.map